import axiosRequest from '@/utils/request'
import axios from 'axios'
// 转账
export const transfer = (data) => {
  return axiosRequest({
    url: '/trade/transfer',
    data,
    method: 'post',
    showMessage: false
  })
}
// 银行列表
export const getBankList = (params) => {
  return axiosRequest({
    url: '/basic-data/get-bank-list',
    params,
    method: 'get'
  })
}
// 结果页面
export const tradeDetail = (data, cancelToken) => {
  return axiosRequest({
    url: '/trade/trade-detail',
    data,
    method: 'post'
  }, {
    cancelToken: new axios.CancelToken((cancel) => {
      cancelToken && cancelToken(cancel)
    })
  })
}

// 转账到账户，验证账号
export const tradeAccountVerify = (data) => {
  return axiosRequest({
    url: '/trade/account-verify',
    data,
    method: 'post',
    showMessage: false
  })
}
